module.exports = __webpack_public_path__ + "static/ania-e598484c337b3c73fdd7b637e801995b.webp";